var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3427_991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8334 9.13672V10.4261C18.0955 11.0567 18.8288 11.8373 18.8288 12.6117C18.8288 14.3864 15.2581 15.7807 11.7254 16.0745C11.4029 16.1011 11.1631 16.3842 11.1901 16.7063C11.2154 17.0162 11.4825 17.2663 11.8219 17.2421C14.897 16.9889 20.0003 15.662 20.0003 12.6117C20.0003 10.9457 18.3702 9.79969 16.8334 9.13672Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47739 14.0851C6.15203 13.754 5.58661 13.9158 5.48731 14.3706L5.22844 15.556C1.35063 14.5123 -0.511169 12.2675 3.17383 10.4261V9.13672C-1.66156 11.2227 -0.90277 15.1406 4.97813 16.7021L4.74536 17.7679C4.64555 18.2248 5.0984 18.6114 5.53516 18.4367L8.46383 17.2652C8.85125 17.1103 8.95743 16.6094 8.66414 16.3109L6.47739 14.0851Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2604 1.59763C10.0798 1.49525 9.85852 1.49619 9.67875 1.59998L4.93066 4.34126C5.7348 4.80552 9.56559 7.01724 10.0026 7.26955L15.0762 4.32658L10.2604 1.59763Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34525 10.8381C4.34525 11.0474 4.45689 11.2407 4.63811 11.3454L9.41783 14.1049V8.28414L4.34521 5.35547V10.8381H4.34525Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6619 10.8379V5.34082L10.5894 8.28321V14.1048L15.3691 11.3452C15.5503 11.2406 15.6619 11.0472 15.6619 10.8379Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3427_991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3D);
export default __webpack_public_path__ + "static/media/3d.85223f6ebe5aac14d001286e808a30ac.svg";
export { ForwardRef as ReactComponent };